import React from "react";
import { AuthenticationInfoType } from "./types";

const AuthenticationContext = React.createContext<AuthenticationInfoType | undefined>(undefined);

export default AuthenticationContext;
